import { addHours } from 'date-fns';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type SessionTimeState = {
  sessionEndTime: Date;
  sessionStartTime: Date;
  lastActionTime: Date;
  isShowingInactivityMessage: boolean;

  setSessionEndTime: (time: Date) => void;
  setSessionStartTime: (time: Date) => void;
  setLastActionTime: () => void;
  setIsShowingInactivityMessage: (isShowing: boolean) => void;
};

export const useSessionTime = create<SessionTimeState>()(
  devtools((set) => ({
    sessionEndTime: addHours(new Date(), 24),
    sessionStartTime: new Date(),
    lastActionTime: new Date(),
    isShowingInactivityMessage: false,

    setSessionEndTime: (time: Date) => set({ sessionEndTime: time }),
    setSessionStartTime: (time: Date) => set({ sessionStartTime: time }),
    setLastActionTime: () => set({ lastActionTime: new Date() }),
    setIsShowingInactivityMessage: (isShowing: boolean) => set({ isShowingInactivityMessage: isShowing }),
  }))
);
